import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';
import { TaskStatusKey } from '../../../../utils/enums';

const TasksFilterBarLoader: React.FC<{
  status: TaskStatusKey;
  tasksCount: number;
}> = ({ status, tasksCount }) => (
  <div className="filter-container d-flex justify-content-between opacity-40">
    <div className="d-flex align-items-center gap-20">
      <SkeletonLoading width={200} height={32} enableAnimation={false} />
    </div>

    <div className="d-flex align-items-center">
      <div className="bs-ml-20">
        <SkeletonLoading width={163} height={32} enableAnimation={false} />
      </div>
      {tasksCount !== 0 &&
        !(
          status === TaskStatusKey.Completed || status === TaskStatusKey.Skipped
        ) && (
          <>
            <div className="filter-border-loader" />
            <SkeletonLoading width={126} height={32} enableAnimation={false} />
          </>
        )}
    </div>
  </div>
);

export default TasksFilterBarLoader;
